import Vue from 'vue'
import viewportUnitsBuggyfill from 'viewport-units-buggyfill'
import { BootstrapVue } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VModal from 'vue-js-modal'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'

viewportUnitsBuggyfill.init({ force: true })

const atoms = require.context('@/components/atoms', true, /\.vue$/)
const proaComponents = {}
atoms.keys().forEach(key => {
  proaComponents[key.replace(/(\.\/|\.vue)/g, '')] = atoms(key).default
})

Object.keys(proaComponents).forEach(key => {
  Vue.component(key, proaComponents[key])
})

Vue.config.productionTip = false

Vue.use(BootstrapVue)

library.add(fas)
Vue.component('v-fa', FontAwesomeIcon)

Vue.use(VModal)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
